import { createFileRoute, redirect } from "@tanstack/react-router";

/** Legacy slug — permanent redirect to the canonical EN URL. */
export const Route = createFileRoute("/retail-location-analysis")({
  beforeLoad: () => {
    throw redirect({ to: "/en/retail-location-analysis", statusCode: 301 });
  },
});
